import React from 'react';
import Breadcrumbs, { BreadcrumbItem } from '@/components/Breadcrumbs';
import { templateLabel } from '../../shared/formUtils';

interface Template {
  category: string;
  sub_category: string;
  variant: string;
}

function buildBreadcrumbs(template: Template | null): BreadcrumbItem[] {
  const indexItem: BreadcrumbItem = {
    label: 'Submission Templates',
    path: '/admin_workflows/submission_templates',
  };

  if (!template) return [indexItem];

  return [
    indexItem,
    { label: templateLabel(template), path: null },
  ];
}

interface SubmissionTemplateBreadcrumbsProps {
  template: Template | null;
}

const SubmissionTemplateBreadcrumbs: React.FC<
  SubmissionTemplateBreadcrumbsProps
> = ({ template }) => <Breadcrumbs items={buildBreadcrumbs(template)} />;

export default SubmissionTemplateBreadcrumbs;
